<div class="webhook-content">
  <div
    *ngFor="let log of webhooksGroupedByRuleName | keyvalue; let last = last"
    class="webhook-content-table">
    <table>
      <tr>
        <th>
          <b>{{ "events.company-call-history.details.webhook-log.table.rule" | Translate }}:</b>
        </th>
        <td>
          <span
            [ngClass]="
              log.key === 'deleted'
                ? 'vox-chip vox-chip_bright-crimson-text ml-2'
                : 'vox-chip vox-chip_royal-blue-text ml-2'
            "
            >{{ log.key }}</span
          >
        </td>
      </tr>
      <tr>
        <th>
          <b>{{ "events.company-call-history.details.webhook-log.table.attempts" | Translate }}:</b>
        </th>
        <td>
          <ng-container *ngFor="let attempt of log.value; let i = index">
            <div class="altempts-content mb-2">
              <b *ngIf="log.value.length >= 2">{{ i + 1 }}.</b>
              <ul class="altempts-list">
                <li>
                  <b>{{ "events.company-call-history.details.webhook-log.table.executed-at" | Translate }}</b
                  >: {{ attempt.executed_at | date: "M/d/yy, h:mm:ss a" }}
                </li>
                <li>
                  <b>{{ "events.company-call-history.details.webhook-log.table.status" | Translate }}</b
                  >:
                  <span
                    *ngIf="attempt.status === webhookStatuses.SENT"
                    class="vox-chip vox-chip_aquamarine-text"
                    >{{ webhookStatuses.SENT }}</span
                  >
                  <span
                    *ngIf="attempt.status === webhookStatuses.FAILED"
                    class="vox-chip vox-chip_bright-crimson-text"
                    >{{ webhookStatuses.FAILED }}</span
                  >
                </li>
                <li>
                  <b>{{ "events.company-call-history.details.webhook-log.table.server-status" | Translate }}</b
                  >: {{ attempt.response_status || "-" }}
                </li>
                <li *ngIf="attempt.error_message">
                  <b>{{ "events.company-call-history.details.webhook-log.table.error-message" | Translate }}</b
                  >: {{ attempt.error_message }}
                </li>
              </ul>
            </div>
          </ng-container>
        </td>
      </tr>
    </table>
    <div
      class="space_block"
      *ngIf="!last"></div>
  </div>
</div>
